import { render } from "./Phone.vue?vue&type=template&id=67462e3a&scoped=true"
import script from "./Phone.vue?vue&type=script&lang=js"
export * from "./Phone.vue?vue&type=script&lang=js"

import "./Phone.vue?vue&type=style&index=0&id=67462e3a&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67462e3a"]])

export default __exports__